import { useSelector } from 'react-redux'
import './resumen.css'
import NumberFormat from 'react-number-format'
import { useMediaQuery } from '@mui/material'

export const Resumen = () => {

    const pptoDetail = useSelector(state => state.ppto.detail)

    return (
        <div className='col p-pptos-form-tablax p-0 animate__animated animate__fadeIn'>
            <div className="row m-3">
                <InfoIngresos totales={pptoDetail} />
                <InfoEgresos totales={pptoDetail} />
            </div>
        </div>
    )
}

const InfoIngresos = ({ totales }) => {

    const {
        separacion_miles,
        separacion_decimales,
        simbolo,
        total_cliente,
        total_ingresos_proyectados,
        total_ingresos_por_proyectar,
        total_facturado,
        total_por_facturar,
        total_cobrado,
        total_por_cobrar
    } = totales

    return (
        <div className="col p-pptos-form-tabla p-2">
            <h5 className="m-2" style={{ color: '#07bc0c', fontSize: '16px' }}>Ingresos</h5>
            <div className='p-resumen-box'>
                <div className='totales'>
                    <div className='title-box'>Total venta</div>
                    <div className='montos'>
                        <NumberFormat
                            displayType={'text'}
                            name="total_item"
                            value={parseFloat(total_cliente || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                </div>
                <div className='mt-2 totales d-flex justify-content-between align-items-center'>
                    <div>
                        <div className='title-box'>Total proyectado</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_ingresos_proyectados || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                    <div className='me-2'>
                        <div className='title-box'>Saldo por proyectar</div>
                        <div className='text-end montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_ingresos_por_proyectar || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                </div>
                <div className='mt-2 totales d-flex justify-content-between align-items-center'>
                    <div>
                        <div className='title-box'>Facturado</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_facturado || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                    <div className='me-2'>
                        <div className='text-end title-box'>Por Facturar</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_por_facturar || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                </div>
                <div className='mt-2 totales d-flex justify-content-between align-items-center'>
                    <div>
                        <div className='title-box'>Cobrado</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_cobrado || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(+ IGV)</span>
                        </div>
                    </div>
                    <div className='me-2'>
                        <div className='text-end title-box'>Por cobrar</div>
                        <div className='text-end montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_por_cobrar || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(+ IGV)</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const InfoEgresos = ({ totales }) => {

    const isMobile = useMediaQuery('(max-width:768px)');

    const {
        separacion_miles,
        separacion_decimales,
        simbolo,
        total_gasto_p,
        total_egresos_proyectados,
        total_egresos_por_proyectar,
        total_gasto_r,
        total_por_gastar,
        total_pagado,
        total_por_pagar
    } = totales

    return (
        <div className={`col p-pptos-form-tabla p-2 ${isMobile ? 'mb-5' : ''}`}>
            <h5 className="m-2" style={{ color: '#e74c3c', fontSize: '16px' }}>Egresos</h5>
            <div className='p-resumen-box'>
                <div className='totales'>
                    <div className='title-box'>Total costos</div>
                    <div className='montos'>
                        <NumberFormat
                            displayType={'text'}
                            name="total_item"
                            value={parseFloat(total_gasto_p || 0)}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                            decimalScale={2}
                            fixedDecimalScale={2}
                        />
                        <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                    </div>
                </div>
                <div className='mt-2 totales d-flex justify-content-between align-items-center'>
                    <div>
                        <div className='title-box'>Total proyectado</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_egresos_proyectados || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                    <div className='me-2'>
                        <div className='title-box'>Saldo por proyectar</div>
                        <div className='text-end montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_egresos_por_proyectar || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                </div>
                <div className='mt-2 totales d-flex justify-content-between align-items-center'>
                    <div>
                        <div className='title-box'>Gastado</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_gasto_r || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                    <div className='me-2'>
                        <div className='text-end title-box'>Por gastar</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_por_gastar || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(neto)</span>
                        </div>
                    </div>
                </div>
                <div className='mt-2 totales d-flex justify-content-between align-items-center'>
                    <div>
                        <div className='title-box'>Pagado</div>
                        <div className='text-start montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_pagado || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(+ IGV)</span>
                        </div>
                    </div>
                    <div className='me-2'>
                        <div className='text-end title-box'>Por pagar</div>
                        <div className='text-end montos'>
                            <NumberFormat
                                displayType={'text'}
                                name="total_item"
                                value={parseFloat(total_por_pagar || 0)}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={2}
                                fixedDecimalScale={2}
                            />
                            <span style={{ color: 'gray', fontSize: '11px' }} className="ms-1">(+ IGV)</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}